export enum FileSystemDirectoryTypes {
  Sub = 'sub',
  Root = 'root',
  Library = 'library',
  EntityRoot = 'entityRoot',
  Entity = 'entity',
}
